import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CurationManagementState } from './types';

export const initialState: CurationManagementState = {
  loading: false,
  curationLoading: false,
  error: '',
  clicks: [],
  insights: {},
  placements: {
    placements: [],
    channels: [],
    streams: []
  },
  oldCurations: [],
  oldCuration: null,
  oldCurationSubs: [],
  oldCurationSub: null,
  qnas: [],
  curations: [],
  curation: null,
  chapters: [],
  chapter: null,
  chaptersLoading: false,
  chaptersError: null,
  questionAnswers: [],
  simulateResult: null,
  simulateResults: {},
  simulateLoading: false
};

const curationManagementSlice = createSlice({
  name: 'curationManagement',
  initialState,
  reducers: {
    fetchClicks: (state, payload) => {
      state.loading = true;
      state.error = '';
    },
    fetchClicksSuccess: (state, action) => {
      state.loading = false;
      state.clicks = action.payload;
    },
    fetchClicksFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchInsights: (state, payload) => {
      state.loading = true;
      state.error = '';
    },
    fetchInsightsSuccess: (state, action) => {
      state.loading = false;
      state.insights = action.payload;
    },
    fetchInsightsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    getChannelsByMarketerId: (state, action) => {
      state.loading = true;
      state.error = '';
    },
    getChannelsByMarketerIdSuccess: (state, action) => {
      state.loading = false;
      state.error = '';
      state.placements = action.payload;
    },
    getChannelsByMarketerIdFailure: (state, action) => {
      state.loading = true;
      state.error = action.payload;
    },
    getAllCurationsByMarketerId: (state, action) => {
      state.loading = true;
      state.error = '';
    },
    getAllCurationsByMarketerIdSuccess: (state, action) => {
      state.loading = false;
      state.error = '';
      state.oldCurations = action.payload;
    },
    getAllCurationsByMarketerIdFailure: (state, action) => {
      state.loading = true;
      state.error = action.payload;
    },
    resetCurations: state => {
      state.oldCurations = [];
    },
    updateCuration: (state, action) => {
      state.loading = true;
      state.error = '';
    },
    updateCurationSuccess: state => {
      state.loading = false;
      state.error = '';
    },
    updateCurationFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    createCuration: (state, action) => {
      state.loading = true;
      state.error = '';
    },
    createCurationSuccess: state => {
      state.loading = false;
      state.error = '';
    },
    createCurationFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    deleteCuration: (state, action) => {
      state.loading = true;
      state.error = '';
    },
    deleteCurationSuccess: state => {
      state.loading = false;
      state.error = '';
    },
    deleteCurationFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    getCurationDetails: (state, action) => {
      state.loading = true;
      state.error = '';
      state.oldCuration = null;
    },
    getCurationDetailsSuccess: (state, action) => {
      state.loading = false;
      state.error = '';
      state.oldCuration = action.payload;
      state.curation = action.payload;
    },
    getCurationDetailsFailure: (state, action) => {
      state.loading = true;
      state.error = action.payload;
    },
    resetCuration: state => {
      state.oldCuration = null;
    },
    getAllSubCurationsByCuration: (state, action) => {
      state.loading = true;
      state.error = '';
    },
    getAllSubCurationsByCurationSuccess: (state, action) => {
      state.loading = false;
      state.error = '';
      state.oldCurationSubs = action.payload;
    },
    getAllSubCurationsByCurationFailure: (state, action) => {
      state.loading = true;
      state.error = action.payload;
    },
    createSubCuration: (state, action) => {
      state.loading = true;
      state.error = '';
    },
    createSubCurationSuccess: state => {
      state.loading = false;
      state.error = '';
    },
    createSubCurationFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    updateSubCuration: (state, action) => {
      state.loading = true;
      state.error = '';
    },
    updateSubCurationSuccess: state => {
      state.loading = false;
      state.error = '';
    },
    updateSubCurationFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    deleteSubCuration: (state, action) => {
      state.loading = true;
      state.error = '';
    },
    deleteSubCurationSuccess: state => {
      state.loading = false;
      state.error = '';
    },
    deleteSubCurationFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    resetSubCurations: state => {
      state.oldCurationSubs = [];
    },
    getSubCurationQnAs: (state, action) => {
      state.loading = true;
      state.error = '';
    },
    getSubCurationQnAsSuccess: (state, action) => {
      state.loading = false;
      state.error = '';
      state.qnas = action.payload;
    },
    getSubCurationQnAsFailure: (state, action) => {
      state.loading = true;
      state.error = action.payload;
    },
    updateQnA: (state, action) => {
      state.loading = true;
      state.error = '';
    },
    updateQnASuccess: state => {
      state.loading = false;
      state.error = '';
    },
    updateQnAFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    addQnA: (state, action) => {
      state.loading = true;
      state.error = '';
    },
    addQnASuccess: state => {
      state.loading = false;
      state.error = '';
    },
    addQnAFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    deleteQnA: (state, action) => {
      state.loading = true;
      state.error = '';
    },
    deleteQnASuccess: state => {
      state.loading = false;
      state.error = '';
    },
    deleteQnAFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    resetQnAs: state => {
      state.qnas = [];
    },
    getCurations: (state, action) => {
      state.loading = true;
      state.error = '';
    },
    getCurationsSuccess: (state, action) => {
      state.loading = false;
      state.error = '';
      state.curations = action.payload;
    },
    getCurationsFailure: (state, action) => {
      state.loading = true;
      state.error = action.payload;
    },
    getChaptersByCuration: (state, action) => {
      state.curationLoading = true;
      state.error = '';
    },
    getChaptersByCurationSuccess: (state, action) => {
      state.curationLoading = false;
      state.chapters = action.payload;
    },
    getChaptersByCurationFailure: (state, action) => {
      state.curationLoading = false;
      state.error = action.payload;
    },
    resetChapters: state => {
      state.chapters = [];
    },
    getChapterDetails: (state, action) => {
      state.loading = true;
      state.error = '';
    },
    getChapterDetailsSuccess: (state, action) => {
      state.loading = false;
      state.chapter = action.payload;
    },
    getChapterDetailsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    selectChapter: (state, action) => {
      state.chapter = action.payload;
    },
    resetChapter: state => {
      state.chapter = null;
    },
    createChapter: (state, action) => {
      state.loading = true;
      state.error = '';
    },
    createChapterSuccess: (state, action) => {
      state.loading = false;
      state.error = '';
      state.chapter = action.payload.data;
    },
    createChapterFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    updateChapter: (state, action) => {
      state.loading = true;
      state.error = '';
    },
    updateChapterSuccess: (state, action) => {
      state.loading = false;
      state.chapter = action.payload;
    },
    updateChapterFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    deleteChapter: (state, action: PayloadAction<{ chapterId: string; callBack?: () => void }>) => {
      state.loading = true;
      state.error = '';
    },
    deleteChapterSuccess: (state, action) => {
      state.loading = false;
      if (action.payload.data) {
        const deletedId = action.payload.data.id;
        const oldChapters = state.chapters;
        const idx = oldChapters.findIndex(ch => ch.id === deletedId);
        const newChapters = oldChapters.filter(ch => ch.id !== deletedId);
        state.chapters = newChapters;
        if (state.chapter?.id === deletedId) {
          state.chapter = idx > 0 ? oldChapters[idx - 1] : newChapters[0] || null;
        }
      }
      state.error = '';
    },
    deleteChapterFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    resetState: () => {
      return initialState;
    },
    simulateQuestionForSocialFeed: (state, action) => {
      state.simulateLoading = true;
      state.error = '';
    },
    simulateQuestionForSocialFeedSuccess: (state, action) => {
      state.simulateLoading = false;

      if (action.payload && action.payload.endpoint) {
        const url = new URL(action.payload.endpoint);
        const questionId = url.searchParams.get('question');

        if (questionId) {
          state.simulateResults = {
            ...state.simulateResults,
            [questionId]: action.payload
          };
        }
      }
    },
    simulateQuestionForSocialFeedFailure: (state, action) => {
      state.simulateLoading = false;
      state.error = action.payload;
    }
  }
});

export const {
  fetchClicks,
  fetchClicksSuccess,
  fetchClicksFailure,
  fetchInsights,
  fetchInsightsSuccess,
  fetchInsightsFailure,
  getChannelsByMarketerId,
  getChannelsByMarketerIdSuccess,
  getChannelsByMarketerIdFailure,
  getAllCurationsByMarketerId,
  getAllCurationsByMarketerIdSuccess,
  getAllCurationsByMarketerIdFailure,
  resetCurations,
  updateCuration,
  updateCurationSuccess,
  updateCurationFailure,
  createCuration,
  createCurationSuccess,
  createCurationFailure,
  deleteCuration,
  deleteCurationSuccess,
  deleteCurationFailure,
  getCurationDetails,
  getCurationDetailsSuccess,
  getCurationDetailsFailure,
  resetCuration,
  getAllSubCurationsByCuration,
  getAllSubCurationsByCurationSuccess,
  getAllSubCurationsByCurationFailure,
  createSubCuration,
  createSubCurationSuccess,
  createSubCurationFailure,
  updateSubCuration,
  updateSubCurationSuccess,
  updateSubCurationFailure,
  deleteSubCuration,
  deleteSubCurationSuccess,
  deleteSubCurationFailure,
  resetSubCurations,
  getSubCurationQnAs,
  getSubCurationQnAsSuccess,
  getSubCurationQnAsFailure,
  resetQnAs,
  updateQnA,
  updateQnASuccess,
  updateQnAFailure,
  addQnA,
  addQnASuccess,
  addQnAFailure,
  deleteQnA,
  deleteQnASuccess,
  deleteQnAFailure,
  getCurations,
  getCurationsSuccess,
  getCurationsFailure,
  getChaptersByCuration,
  getChaptersByCurationSuccess,
  getChaptersByCurationFailure,
  resetChapters,
  getChapterDetails,
  getChapterDetailsSuccess,
  getChapterDetailsFailure,
  selectChapter,
  resetChapter,
  createChapter,
  createChapterSuccess,
  createChapterFailure,
  updateChapter,
  updateChapterSuccess,
  updateChapterFailure,
  resetState,
  simulateQuestionForSocialFeed,
  simulateQuestionForSocialFeedSuccess,
  simulateQuestionForSocialFeedFailure,
  deleteChapter,
  deleteChapterSuccess,
  deleteChapterFailure
} = curationManagementSlice.actions;

export default curationManagementSlice.reducer;
